import { SocialMedia } from "./SocialMedia";
export const Footer = () => {
  const year: string = new Date().getFullYear().toString();
  return (
    <footer className="footer footer-black footer-big">
      <div className="container">
        <div className="row">
          <div className="col-md-4 col-sm-4 ml-auto mr-auto">
            <div>
              <h3>Hanna Kaciniel </h3>
              <small>©{year}</small>
            </div>
          </div>
          <div className="col-md-4 col-sm-4 ml-auto mr-auto">
            <div className="links">
              <ul>
                <li>
                  <SocialMedia
                    Class="col-md-12 social-media-footer"
                    Type="Footer"
                  />
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};
